import type { TSliceReducer } from 'core/store';
import { initialState } from './orders.constants';
import type { IOrdersState } from './orders.type';

const updateOrderFilters: TSliceReducer<IOrdersState, { ByOrder: string; ByClient: string }> = (state, action) => {
  state.filters = { ...state.filters, ...action.payload };
};

const resetOrderDetail: TSliceReducer<IOrdersState> = state => {
  state.orderDetail = initialState.orderDetail;
};

export const reducers = { updateOrderFilters, resetOrderDetail };
